module.exports = __webpack_public_path__ + "static/media/SN.41f2c317.svg";